/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 10:40:10
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

import { IOrderExtensionData } from '@root/types/order';
import { http } from '@shared';

const checkGiftCard = (code: string) => {
  return http.request({
    url: `/api/ipc/giftCard/check/${code}`,
  });
};

// 获取礼品卡关联套餐
const getPackagesByCode = (code: string) => {
  return http.request({
    url: `/api/ipc/giftCard/goods/${code}`,
  });
};

// 获取礼品卡 可支持延期的已有服务
const getGiftCardExtensionGoods = (code: string) => {
  return http.request({
    url: `/api/ipc/giftCard/subscribeGoods/${code}`,
  });
};

// 获取礼品卡延期已有服务订单
const createGiftCardExtensionOrder = (data: IOrderExtensionData) => {
  return http.request({
    url: '/payGateway/serviceExtension',
    method: 'POST',
    data,
  });
};

// 获取：礼品卡&自动发放服务可订阅的套餐
const getGoodsInfoByPackageId = (id: string) => {
  return http.request({
    url: `/api/ipc/recordPlanController/getGoodsInfoByPackageId?packageId=${id}`,
  });
};

export {
  checkGiftCard,
  getPackagesByCode,
  getGiftCardExtensionGoods,
  getGoodsInfoByPackageId,
  createGiftCardExtensionOrder,
};
